export const LUC = '0016';

export default LUC;
